import React from "react";
import Dialog from "material-ui/Dialog";
import { FormattedMessage, injectIntl } from 'react-intl';
import images from '../../config/images';
import TextField from 'material-ui/TextField';
import Toggle from 'material-ui/Toggle'
import FlatButton from 'material-ui/FlatButton';
import ReactTooltip from 'react-tooltip'
import { checkJapanese, checkMobile, deleteRoom, getOrientation, getRoomInfo, getRoomStatus, getToken, isIpadOS, randomName } from "../../lib";
import config from "../../config/config";
import DialogTitle from "../Shared/DialogTitle";
import DatePicker from 'material-ui/DatePicker';
import moment from "moment-timezone";
import Select from 'react-select';
import HardwareKeyboardArrowDown from "material-ui/svg-icons/hardware/keyboard-arrow-down";
import ArrowDropDown from "material-ui/svg-icons/navigation/arrow-drop-down";
import ArrowDropUp from "material-ui/svg-icons/navigation/arrow-drop-up";
import { Checkbox } from "material-ui";
var eaw = require('eastasianwidth');

const imageStyle = {
  width: '26px',
  height: '26px',
  margin: '0 8px',
  cursor: 'pointer',
  padding: '5px',
  borderRadius: '2px',
  position: 'absolute',
  top: 0,
  right: 0
}

export const labelStyle = {
  color: '#657285',
  fontSize: '14px',
  marginTop: '8px'
}

let textFieldStyle = {
  backgroundColor: '#fff',
  height: '38px',
  margin: '8px 0',

}

let inputStyle = {
  border: '1px solid #657285ab',
  height: '38px',
  padding: '0 8px',
  fontSize: '13px'
}


const Help = (props) => {
  return (
    <span>
      {checkMobile() || isIpadOS() ? <span></span> :<img
      data-tip={`<div class='rc-tooltip'>${props.content}</div>`}
      style={{ width: '16px', height: '16px', marginLeft: '5px', cursor: 'pointer' }}
      src={images.quetionMark}
    />}
    </span>
  )
}

const MinuteSelectDropDown = (props) => {
  return (
    <div className="other-ele-cont" style={props.style}>
      <span className="time-dropdwon-icon divider" />
      <HardwareKeyboardArrowDown
        onClick={props.handleClick}
        className={`time-dropdwon-icon ${props.isActive ? 'td-active' : ''}`}
      />
    </div>
  )
}

export const OptionsCheckbox = (props) => {
  return (
    <Checkbox
      iconStyle={{ marginRight: '2px'}}
      className="room-options-list-checkbox"
      label={props.label}
      style={{ marginBottom: '16px' }}
      checked={props.checked}
      onCheck={props.handleCheck}
    />
  )
}

class CreateAndEditRoom extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      password: '',
      locked: false,
      roomExpiration: false,
      hasError: false,
      hasRoomNameError: '',
      errorMessage: '',
      startDate: null,
      startTime: null,
      endDate: null,
      endTime: null,
      hasRoomExpirationError: false,
      roomExpirationError: null,
      startTimeHours: null,
      endTimeHours: null,
      startTimeMinutes: null,
      endTimeMinutes: null,
      isEndTimeMenuOpen: false,
      isStartTimeMenuOpen: false,
      showOptions: false,
      options: {
        microphoneControl: false,
        camControl: false,
        screenShareControl: false,
        recordingControl: false
      }
    }
    this.passwordRef = null;
    this.timeSlots= [];
  }

  componentDidMount() {
    this.getTimeIntervals();
    if(this.props.isEdit) {
      this.setRoomData();
    }
  }

  getTimeIntervals = () => {
    var hoursList = [];
    for(var i = 0; i < 24; i++){
      i = (i<10) ? "0"+i : i;
      hoursList.push({ value: i, label: i });
    }
    this.timeSlots['hours'] = hoursList;
    this.timeSlots['minutes'] = [{ value: '00', label: '00'},{ value: '15', label: '15'},{ value: '30', label: '30'},{ value: '45', label: '45'},];
  }

  setRoomData = () => {
    if(this.props.selectedRoom) {
      if(this.props.selectedRoom.fvroom_password) {
        if(this.passwordRef) {
          this.passwordRef.input.type = 'password';
        }
      }

      const showOptions = this.props.selectedRoom.mute_microphone_control || this.props.selectedRoom.mute_cam_control || this.props.selectedRoom.disable_room_recording || this.props.selectedRoom.disable_screen_sharing;

      let options = this.state.options;
      if(showOptions) {
        options = {
          microphoneControl: this.props.selectedRoom.mute_microphone_control,
          camControl: this.props.selectedRoom.mute_cam_control,
          screenShareControl: this.props.selectedRoom.disable_screen_sharing,
          recordingControl: this.props.selectedRoom.disable_room_recording
        }
      }

      this.setState({
        name: this.props.selectedRoom.fvroom_name || '',
        password: this.props.selectedRoom.fvroom_password || '',
        locked: this.props.selectedRoom.locked || false,
        roomExpiration: this.props.selectedRoom.has_expiration || false,
        showOptions,
        options
      });

      if(this.props.selectedRoom.has_expiration) {
        if(this.props.selectedRoom.expiration_start_date.split('-').length > 1 && this.props.selectedRoom.expiration_end_date.split('-').length > 0) {
          const start = new Date(moment.tz(this.props.selectedRoom.expiration_start_date, "UTC").tz(moment.tz.guess() || 'Asia/Tokyo').toDate());
          const end = new Date(moment.tz(this.props.selectedRoom.expiration_end_date, "UTC").tz(moment.tz.guess() || 'Asia/Tokyo').toDate());
          let startTimeMinutes = start.getMinutes();
          let endTimeMinutes = end.getMinutes();
          if(startTimeMinutes < 10) {
            startTimeMinutes = "0" + startTimeMinutes
          }
          if(endTimeMinutes < 10) {
            endTimeMinutes = "0" + endTimeMinutes
          }

          this.setState({
            startDate: start,
            startTime: start,
            endDate: end,
            endTime: end,
            startTimeHours: this.timeSlots.hours.find(item => item.value == start.getHours()),
            startTimeMinutes: { label: startTimeMinutes.toString(), value: startTimeMinutes.toString() },
            endTimeHours: this.timeSlots.hours.find(item => item.value == end.getHours()),
            endTimeMinutes: { label: endTimeMinutes.toString(), value: endTimeMinutes.toString() },
          })
        }
      }
    }
  }

  clearForm = () => {
    this.setState({ name: '', password: '', locked: false, roomExpiration: false, startDate:'', startTime:'', endDate:'', endTime: '', startTimeHours: '', endTimeHours: '', startTimeMinutes: '', endTimeMinutes: '' });
  }

  validateRoomName = () => {
    return this.state.name.match(/^[a-z0-9-]*$/)
  }

  isRoomValid = (roomExpirationDates) => {
    if (!this.validateRoomName()) {
      this.setState({
        hasRoomNameError: checkJapanese()
          ? `小文字アルファベットと数字とハイフンのみ使用できます`
          : `small alphabet and number and hyphen is only allowed.`
      });
      return false;
    } else if(this.state.roomExpiration){
      if(!this.state.startTimeHours || !this.state.startTimeMinutes || !this.state.endTimeHours || !this.state.endTimeMinutes) {
        this.setState({ hasRoomExpirationError: true, roomExpirationError: <FormattedMessage id="helper.roomExpiration.timeError" /> });
        return false
      }
      if(!roomExpirationDates.expiration_start_date || !roomExpirationDates.expiration_end_date) {
        this.setState({ hasRoomExpirationError: true, roomExpirationError: <FormattedMessage id="helper.roomExpiration.invalidDate" /> });
        return false
      }
      const startDate = moment(new Date(roomExpirationDates.expiration_start_date));
      const endDate = moment(new Date(roomExpirationDates.expiration_end_date));
      const currentUtcTime = moment(new Date((moment.utc(new Date()).format('YYYY-MM-DD HH:mm'))));

      if(startDate.isBefore(moment(currentUtcTime))) {
        this.setState({ hasRoomExpirationError: true, roomExpirationError: <FormattedMessage id="helper.roomExpiration.beforeTimeError" /> });
        return false;
      }

      if(endDate.isBefore(startDate)) {
        this.setState({ hasRoomExpirationError: true, roomExpirationError: <FormattedMessage id="helper.roomExpiration.endTimeBeforeStartError" /> });
        return false;
      }

      this.setState({ hasRoomExpirationError: false, roomExpirationError: null });
      return true;
    } else {
      return true;
    }
  }

  isTotalLimitExceeded = () => {
    if (this.props.alreadyCreatedRooms >= this.props.max_room_num_per_user) {
      this.setState({
        hasError: true,
        errorMessage: checkJapanese()
        ? `部屋の作成ができません。現在の最大数は ${this.props.max_room_num_per_user}です。`
        : `I cannot create a room. The current maximum is ${this.props.max_room_num_per_user}`
      });
      return true;
    } else {
      return false;
    }
  }

  destroyRoom = async() => {
    const { formatMessage } = this.props.intl;
    const id = this.props.selectedRoom.id;
    const room = this.props.selectedRoom;
    try {
      if(this.props.isWebinar) {
        let roomStatus = await getRoomStatus('sfu', room.fvroom_name, this.props.domainUrlName, true);
        this.handleRoomStatus(roomStatus, id);
      } else {
        let roomInfo = await getRoomInfo(room.fvroom_name, this.props.isWebinar, this.props.domainUrlName);
        if(roomInfo.status === 'success' && roomInfo.data && roomInfo.data.connection_type) {
          let roomStatus = await getRoomStatus(roomInfo.data.connection_type, room.fvroom_name, this.props.domainUrlName, false);
          this.handleRoomStatus(roomStatus, id);
        } else {
          window.confirm(formatMessage({ id: "loggedInNavigation.deleteRoomMessage" })) ? this.deleteUsingId(id) : '';
        }
      }
    } catch (error) {
      this.setState({
        hasError: true,
        errorMessage: checkJapanese() ? 'サーバーとの接続にエラーが発生しました。' : 'There was an error connecting to the server.'
      });
      console.log('file: SessionsRoom.js ~ line 121 ~ SessionsRoom ~ destroyRoom= ~ error', error);
    }
  }

  handleRoomStatus = (roomStatus, id) => {
    const { formatMessage } = this.props.intl;
    if(roomStatus && roomStatus.success && roomStatus.data.length === 0) {
      window.confirm(formatMessage({ id: "loggedInNavigation.deleteRoomMessage" })) ? this.deleteUsingId(id) : '';
    } else if(roomStatus && roomStatus.success && roomStatus.data.length > 0) {
      window.confirm(formatMessage({ id: "loggedInNavigation.deleteConfirmation" })) ? this.deleteUsingId(id) : '' ;
    } else {
      window.confirm(formatMessage({ id: "loggedInNavigation.deleteRoomMessage" })) ? this.deleteUsingId(id) : '';
    }
  }

  deleteUsingId = (id) => {
    deleteRoom(id, getToken())
    .then(res => {
        console.log('done')
        this.props.onClose();
      })
      .catch((error) => {
        console.log("Error -> ", error)
        this.setState({
          hasError: true,
          errorMessage: checkJapanese() ? 'サーバーとの接続にエラーが発生しました。' : 'There was an error connecting to the server.'
        });
      })
  }

  getRoomExpirationData = () => {
    if(this.state.roomExpiration) {
      if(!this.state.startTimeHours || !this.state.startTimeMinutes || !this.state.endTimeHours || !this.state.endTimeMinutes) {
        this.setState({ hasRoomExpirationError: true, roomExpirationError: <FormattedMessage id="helper.roomExpiration.timeError" /> });
        return false
      }
      console.log(this.state);
      const startDate = new Date(this.state.startDate);
      startDate.setHours(0, 0, 0, 0);
      startDate.setHours(startDate.getHours() + parseInt(this.state.startTimeHours.value));
      startDate.setMinutes(startDate.getMinutes() + parseInt(this.state.startTimeMinutes.value));
      const endDate = new Date(this.state.endDate);
      endDate.setHours(0, 0, 0, 0);
      endDate.setHours(endDate.getHours() + parseInt(this.state.endTimeHours.value));
      endDate.setMinutes(endDate.getMinutes() + parseInt(this.state.endTimeMinutes.value));
      return {
        expiration_start_date: (moment.utc(startDate).format('YYYY-MM-DD HH:mm')),
        expiration_end_date:  (moment.utc(endDate).format('YYYY-MM-DD HH:mm')),
        timezone: moment.tz.guess()
      }
    } else {
      return {
        expiration_start_date: null,
        expiration_end_date: null,
        timezone: moment.tz.guess()
      }
    }
  }

  updateRoom = () => {
    const roomExpirationDates = this.getRoomExpirationData();
    if(!this.isRoomValid(roomExpirationDates)) {
      return;
    }

    let payload = {
      fvroom_name: this.state.name.length === 0
        ? Math.random().toString(36).substr(2, 6)
        : this.state.name,
      fvroom_password: this.state.password,
      locked: this.state.locked,
      has_expiration: this.state.roomExpiration,
      mute_microphone_control: this.state.options.microphoneControl,
      mute_cam_control: this.state.options.camControl,
      disable_screen_sharing: this.state.options.screenShareControl,
      disable_room_recording: this.state.options.recordingControl,
    }

    payload = {...payload, ...roomExpirationDates}

    return fetch(`${config.URI}/api/v1/rooms/${this.props.selectedRoom.id}`, {
      method: 'POST',
      headers: {
        'Authenticity-Token': getToken(),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then((temp) => temp.json())
      .then(res => {
        this.props.onClose(res.data, false);
      })
      .catch((error) => {
        this.setState({hasError: true, errorMessage: checkJapanese() ? 'サーバーとの接続にエラーが発生しました。' : 'There was an error connecting to the server.'});
    })

  }

  createRoom = () => {
    const roomExpirationDates = this.getRoomExpirationData();
    if(!this.isRoomValid(roomExpirationDates)) {
      return;
    }

    if(this.isTotalLimitExceeded()) {
      return;
    }

    let payload = {
      name: randomName(),
      fvroom_name: this.state.name.length === 0
        ? Math.random().toString(36).substr(2, 6)
        : this.state.name,
      room_type: `fvlite`,
      is_webinar: this.props.isWebinar,
      fvroom_password: this.state.password,
      locked: this.state.locked,
      has_expiration: this.state.roomExpiration,
      mute_microphone_control: this.state.options.microphoneControl,
      mute_cam_control: this.state.options.camControl,
      disable_screen_sharing: this.state.options.screenShareControl,
      disable_room_recording: this.state.options.recordingControl,
    };

    payload = {...payload, ...roomExpirationDates}
    console.log("Payload", payload);

    return fetch(`${config.URI}/api/v1/rooms`, {
      method: 'POST',
      headers: {
        'Authenticity-Token': getToken(),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    }).then((temp) => temp.json())
      .then(res => {
        if (res.status && res.status === 'success') {
          // Success message goes here
          this.props.onClose(res.data.room, true);
        } else {
          if (res.errors.room[0] == 'Name has already been taken' || res.errors.room == 'Room already exists') {
            this.setState({hasError: true, errorMessage: checkJapanese() ? '同じ部屋名が存在します' : 'Same room name exists'});
          } else {
            this.setState({hasError: true, errorMessage: checkJapanese() ? '例外的なエラーが発生しました。' : 'An exceptional error has occurred.'});
          }
        }
      })
      .catch((err) => {
        this.setState({hasError: true, errorMessage: checkJapanese() ? 'サーバーとの接続にエラーが発生しました。' : 'There was an error connecting to the server.'});
      })
  }

  resetError = () => {
    this.setState({hasError: false, errorMessage: ''});
  }

  shouldDisableDate = (date) => {
    return moment(date).isBefore(moment()) && moment(date).format('YYYY-MM-DD') !== moment().format('YYYY-MM-DD');
  }

  resetDateError = () => {
    this.setState({ hasRoomExpirationError: false, roomExpirationError: null })
  }

  getSelectStyle = (isHidden) => {
    return {
      option: (provided, state) => ({
        ...provided,
        cursor: 'pointer',
        backgroundColor: state.isFocused ? "#657285 !important" : "#fff !important",
        color: state.isFocused ? "#fff !important" : "#657285 !important",
        fontSize: '13px',
      }),
      control: (provided) => ({
        ...provided,
        border: '1px solid rgba(101, 114, 133, 0.67) !important',
        boxShadow: 'none',
        borderRadius: 0,
        fontSize: '13px',
        color: '#000',
        visibility: isHidden ? 'hidden !important' : 'unset'
      }),
      singleValue: (provided) => {
        color: '#000'
      },
      placeholder: (provided) => ({
        ...provided,
        color: '#b3b3b3'
      })
    }
  }

  handleStartMinutesBlur = (e) => {
    try {
      let minute = this.state.startTimeMinutes.value;
      if(!this.isHalfWidth(minute)) {
        minute = this.fullWidthNumConvert(minute)
      }
      const value = minute < 60 ? minute : 59
      this.setState({ startTimeMinutes: { value, label: value } });
      setTimeout(() => {
        this.setState({isStartTimeMenuOpen: false})
      }, 150);
    } catch (error) {}
  }

  isHalfWidth = (c) => { return eaw.characterLength(c) == 1; }

  fullWidthNumConvert = (fullWidthNum) => {
    return fullWidthNum.replace(/[\uFF10-\uFF19]/g, function(m) {
      return String.fromCharCode(m.charCodeAt(0) - 0xfee0);
    });
}

  handleEndMinutesBlur = (e) => {
    try {
      let minute = this.state.endTimeMinutes.value;
      if(!this.isHalfWidth(minute)) {
        minute = this.fullWidthNumConvert(minute)
      }
      const value = minute < 60 ? minute : 59
      this.setState({ endTimeMinutes: { value, label: value } });
      setTimeout(() => {
        this.setState({isEndTimeMenuOpen: false})
      }, 150);
    } catch (error) {}
  }

  handleOptionSelect = (key) => {
    const options = this.state.options;
    options[key] = !this.state.options[key] || false;
    this.setState({ options });
  }

  render() {
    console.log(this.props);
    const { formatMessage } = this.props.intl;

    const actions = [
      <FlatButton
        label={<FormattedMessage id="seminarActions.clear" />}
        labelStyle={{ color: "#858585" }}
        onClick={this.clearForm}
      />,
      <FlatButton
        backgroundColor="#60d1bd"
        hoverColor="#60d1bd"
        label={<FormattedMessage id="seminar.save" />}
        labelStyle={{ color: "#fff" }}
        onClick={() => {
          this.props.isEdit ? this.updateRoom() : this.createRoom();
        }}
      />,
    ];


    if(this.props.isEdit) {
      actions.unshift(<FlatButton
        backgroundColor="#d75654"
        hoverColor="#d75654"
        label={<FormattedMessage id='roomList.delete' />}
        labelStyle={{ color: '#fff' }}
        onClick={this.destroyRoom}
      />)
    }

    let placeholders = {
      room: formatMessage({ id: "loggedInNavigation.roomPlaceholder" }),
      password: formatMessage({ id: "loggedInNavigation.passwordPlaceholder" }),
      hour: formatMessage({ id: "seminar.hour" }),
      min: formatMessage({ id: "seminar.min" }),
    }

    let texts =  {
      name: formatMessage({ id: "helper.conferenceRoom.name" }),
      password: formatMessage({ id: "helper.conferenceRoom.password" }),
      locked: formatMessage({ id: "helper.conferenceRoom.locked" }),
      roomExpiration: formatMessage({ id: "helper.conferenceRoom.roomExpiration" })
    }

    let webinarText = {
      name: formatMessage({ id: "helper.webinarRoom.name" }),
      password: formatMessage({ id: "helper.webinarRoom.password" }),
      locked: formatMessage({ id: "helper.webinarRoom.locked" }),
    }

    return (
      <Dialog
        modal={false}
        title={
          <DialogTitle
            heading={<FormattedMessage id="loggedInNavigation.createEditRoom" />}
            handleClose={this.props.handleClose}
          />
        }
        open={this.props.open}
        onRequestClose={this.props.handleClose}
        contentClassName="popup-modal-content"
        contentStyle={{ maxWidth: '550px', width: '96%' }}
        bodyStyle={{ padding: 0 }}
        autoScrollBodyContent={true}
        actions={actions}
        actionsContainerStyle={{
          display: 'flex',
          justifyContent: 'space-between',
          backgroundColor: 'rgb(241, 241, 241)',
          padding: '12px 28px 15px'
        }}
        className="popup-modal"
        bodyClassName="popup-modal-body"
      >
        <ReactTooltip className="rc-tooltip-container" place='top' multiline effect='solid' html />

        <div
          style={{
            backgroundColor: 'rgb(241, 241, 241)',
            padding: '20px 30px',
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={labelStyle}> <FormattedMessage id='roomList.roomName' /><Help content={this.props.isWebinar ? webinarText.name : texts.name} /></label>
            <TextField
              fullWidth={true}
              underlineShow={false}
              style={textFieldStyle}
              inputStyle={inputStyle}
              value={this.state.name}
              onChange={(e) => {
                this.resetError();
                if(e.target && e.target.value && e.target.value.length <= 20) {
                  this.setState({ name: e.target.value, hasRoomNameError: ''});
                } else if(!e.target.value) {
                  this.setState({ name: '', hasRoomNameError: ''});
                }
              }}
              placeholder={placeholders.room}
              autoComplete="off"
            />
            <label className = "fullwidth-label" style={{ fontSize: '14px', color: 'red', marginBottom: '6px' }}>{this.state.hasRoomNameError}</label>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={labelStyle}> <FormattedMessage id='roomList.password' /><Help content={this.props.isWebinar ? webinarText.password : texts.password} /></label>
            <TextField
              fullWidth={true}
              underlineShow={false}
              style={textFieldStyle}
              inputStyle={inputStyle}
              value={this.state.password}
              type="text"
              onChange={(e) => {
                this.resetError();
                this.setState({ password: e.target.value});
                if(this.passwordRef && this.passwordRef.input && this.passwordRef.input.type === 'password') {
                  this.passwordRef.input.type = 'text';
                }
              }}
              placeholder={placeholders.password}
              autoComplete="new-password"
              ref={ref => this.passwordRef = ref}
            />
          </div>

          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={labelStyle}> <FormattedMessage id='roomList.locked' /><Help content={this.props.isWebinar ? webinarText.locked : texts.locked} /></label>
            <Toggle
              style={{ width: '40px', margin: '8px 0' }}
              toggled={this.state.locked}
              onToggle={(e, isToggled) => {
                this.resetError()
                this.setState({ locked: isToggled })
              }}
              size='medium'
              trackStyle={{
                borderRadius: '12px',
                height: '22px'
              }}
              iconStyle={{
                borderRadius: '20px',
                padding: 0,
                margin: 0
              }}
            />
          </div>

          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={labelStyle}> <FormattedMessage id='roomList.roomExpiration' /><Help content={texts.roomExpiration} /></label>
            <Toggle
              style={{ width: '40px', margin: '8px 0' }}
              toggled={this.state.roomExpiration}
              onToggle={(e, isToggled) => {
                this.resetError()
                this.setState({ roomExpiration: isToggled });
                this.resetDateError();
              }}
              size='medium'
              trackStyle={{
                borderRadius: '12px',
                height: '22px'
              }}
              iconStyle={{
                borderRadius: '20px',
                padding: 0,
                margin: 0
              }}
            />
          </div>
         {this.state.roomExpiration && <div style={{ textAlign: 'center', marginTop: '8px', marginBottom: '12px' }}>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <div className="relative  room-date-picker-container">
                <DatePicker
                  container={getOrientation() === 'landscape' && this.props.view === 'mobile' ? 'inline' : 'dialog'}
                  ref={r => this.startDateRef = r}
                  className="room-date-picker"
                  hintText={<FormattedMessage id='transcriptions.startDate' />}
                  shouldDisableDate={this.shouldDisableDate}
                  textFieldStyle={{ color: '#000'}}
                  value={this.state.startDate}
                  onChange={(e, date) => {
                    this.setState({ startDate: date });
                    this.resetDateError();
                    if(!this.state.startTime) {
                      this.setState({ startTime: date });
                    }
                  }}
                  mode={getOrientation() === 'landscape' && this.props.view === 'mobile' ? 'landscape' : 'portrait'}
                />
                <img style={imageStyle}
                  src={images.calendar}
                  onClick={() => {
                    if(this.startDateRef) {
                      this.startDateRef.refs.dialogWindow.show()
                    }
                  }}
                />
              </div>
              <Select
                styles={this.getSelectStyle(false)}
                menuPlacement="top"
                className = "time-selector"
                options={this.timeSlots.hours}
                onChange={(value) => {
                  this.setState({ startTimeHours: value });
                }}
                placeholder={placeholders.hour}
                value={this.state.startTimeHours}
                isSearchable={false}
              />
              <div style={{ position: 'relative' }}>
                <input
                  placeholder={placeholders.min}
                  className="time-input"
                  value={this.state.startTimeMinutes && this.state.startTimeMinutes.value}
                  onChange={(e) => this.setState({ startTimeMinutes: { value: e.target.value, label: e.target.value } })}
                  onFocus={() => this.setState({isStartTimeMenuOpen: true})}
                  style={{ zIndex: this.state.isEndTimeMenuOpen ? 9 : 99}}
                  onBlur={this.handleStartMinutesBlur}
                />

                <MinuteSelectDropDown
                  handleClick={() => this.setState({ isStartTimeMenuOpen: !this.state.isStartTimeMenuOpen })}
                  style={{zIndex: this.state.isEndTimeMenuOpen ? 9 : 99}}
                  isActive={this.state.isStartTimeMenuOpen}
                />
                <Select
                  styles={this.getSelectStyle(true)}
                  menuPlacement="top"
                  className = "time-selector"
                  options={this.timeSlots.minutes}
                  onChange={(value) => {
                    this.setState({ startTimeMinutes: value, isStartTimeMenuOpen: false });
                  }}
                  placeholder=""
                  value={this.state.startTimeMinutes}
                  menuIsOpen={this.state.isStartTimeMenuOpen}
                  isSearchable={checkMobile() ? false : true}
                />
              </div>
            </div>
            <div style={{ margin: '6px 0'}}>~</div>
            <div style={{ display: 'flex', flexDirection: 'row'}}>
              <div className="relative room-date-picker-container">
                <DatePicker
                  container={getOrientation() === 'landscape' && this.props.view === 'mobile' ? 'inline' : 'dialog'}
                  ref={r => this.endDateRef = r}
                  className="room-date-picker"
                  hintText={<FormattedMessage id='transcriptions.endDate' />}
                  shouldDisableDate={this.shouldDisableDate}
                  value={this.state.endDate}
                  onChange={(e, date) => {
                    console.log("Date: ", date);
                    this.setState({ endDate: date });
                    this.resetDateError();
                    if(!this.state.endTime) {
                      this.setState({ endTime: date });
                    }
                  }}
                  mode={getOrientation() === 'landscape' && this.props.view === 'mobile' ? 'landscape' : 'portrait'}
                />
                <img style={imageStyle}
                  src={images.calendar}
                  onClick={() => {
                    if(this.endDateRef) {
                      this.endDateRef.refs.dialogWindow.show()
                    }
                  }}
                />
              </div>
              <Select
                styles={this.getSelectStyle(false)}
                menuPlacement="top"
                className = "time-selector"
                options={this.timeSlots.hours}
                onChange={(value) => {
                  this.setState({ endTimeHours: value });
                }}
                placeholder={placeholders.hour}
                component={{
                  IndicatorSeparator: () => null
                }}
                value={this.state.endTimeHours}
                isSearchable={false}
              />
              <div style={{ position: 'relative' }}>
                <input
                  className="time-input"
                  value={this.state.endTimeMinutes && this.state.endTimeMinutes.value}
                  onChange={(e) => this.setState({ endTimeMinutes: { value: e.target.value, label: e.target.value } })}
                  onFocus={() => this.setState({isEndTimeMenuOpen: true})}
                  autoComplete="on"
                  onBlur={this.handleEndMinutesBlur}
                  placeholder={placeholders.min}
                />

                <MinuteSelectDropDown
                  handleClick={() => this.setState({ isEndTimeMenuOpen: !this.state.isEndTimeMenuOpen })}
                  isActive={this.state.isEndTimeMenuOpen}
                />

                <Select
                  menuPlacement="top"
                  styles={this.getSelectStyle(true)}
                  className = "time-selector time"
                  options={this.timeSlots.minutes}
                  onChange={(value) => {
                    this.setState({ endTimeMinutes: value, isEndTimeMenuOpen: false });
                  }}
                  menuIsOpen={this.state.isEndTimeMenuOpen}
                  placeholder=""
                  component={{
                    IndicatorSeparator: () => null
                  }}
                  value={[{ value: '15', label: '15'}]}
                  isSearchable={checkMobile() ? false : true}
                />
              </div>
            </div>
          </div>}
          {!this.props.isWebinar && <div>
            <div className="room-options">
              <div className="d-flex items-center options-heading" onClick={() => this.setState({ showOptions: !this.state.showOptions })}>
                <FormattedMessage id='roomList.options' />
                {this.state.showOptions ? <ArrowDropUp /> : <ArrowDropDown />}
              </div>

              {this.state.showOptions && <div className="room-options-list">
                <div>
                  <FormattedMessage id='roomList.microphoneControl' />
                  <OptionsCheckbox checked={this.state.options.microphoneControl} label={<FormattedMessage id='roomList.muteMicrophone' />} handleCheck={() => this.handleOptionSelect('microphoneControl')} />
                </div>
                <div>
                  <FormattedMessage id='roomList.cameraControl' />
                  <OptionsCheckbox checked={this.state.options.camControl} label={<FormattedMessage id='roomList.muteCamera' />} handleCheck={() => this.handleOptionSelect('camControl')} />
                </div>
                <div>
                  <FormattedMessage id='roomList.screenShareControl' />
                  <OptionsCheckbox checked={this.state.options.screenShareControl} label={<FormattedMessage id='roomList.disallowScreenShare' />} handleCheck={() => this.handleOptionSelect('screenShareControl')} />
                </div>
                {/* <div>
                  <FormattedMessage id='roomList.recordingControl' />
                  <OptionsCheckbox checked={this.state.options.recordingControl} label={<FormattedMessage id='roomList.disallowRecording' />} handleCheck={() => this.handleOptionSelect('recordingControl')} />
                </div> */}
              </div>}
            </div>
          </div>}


          {this.state.hasError && this.state.errorMessage && <div className="error-message">{this.state.errorMessage}</div>}
          {this.state.hasRoomExpirationError && this.state.roomExpirationError && <div className="error-message">{this.state.roomExpirationError}</div>}
        </div>
      </Dialog>
    )
  }
}

export default injectIntl(CreateAndEditRoom);



// WEBPACK FOOTER //
// src/components/Seminars/CreateNEditRoom.js